module.exports = __webpack_public_path__ + "static/media/queena.41193fb7.jpeg";